/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://cq9decfuj1.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "api85b3bd57Payment",
            "endpoint": "https://brnv0jgd5k.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://rglz5qm5g5ambl24pqitzgdvbe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-ejh72rbgpjbgzatoeitgixfsla",
    "aws_cognito_identity_pool_id": "us-east-1:f58e091e-0fff-4f02-81c5-d904c983f771",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_qNzgO285z",
    "aws_user_pools_web_client_id": "2ccfo2rtorpnhvuika4j4p30ut",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "virtualsafeevents-20230119163746-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1eylrd69gtg57.cloudfront.net",
    "aws_user_files_s3_bucket": "virtualsafeevents7a85beac93234fb79f888c563e70e2164755-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
